import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FeatureSubscriptionPaymentCycle, FeatureSubscriptionProductCode } from 'queries';

import TaskOverview from 'pages/home-page/components/task-overview';
import { getNameForProduct, getTotalCredits } from 'utils/feature-subscription';
import { getSeatQuantityForProduct } from 'utils/feature-subscription';

type Props = {
  currentPlan: FeatureSubscriptionProductCode | null;
  order: number;
  portalId: string;
  selectedPayCycle: FeatureSubscriptionPaymentCycle;
};

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  headerSubtitle: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  listNumber: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ddd',
    borderRadius: '50%',
    width: '25px',
    height: '25px',
    marginRight: '15px',
  },
  orderedListContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '10px',
  },
  pageContainer: {
    marginLeft: '30px',
    paddingLeft: '26px',
  },
}));

export const PlanOverview = ({ currentPlan, portalId, order, selectedPayCycle }: Props) => {
  const classes = useStyles();

  const plan = getNameForProduct(currentPlan!);
  const cycle =
    selectedPayCycle === FeatureSubscriptionPaymentCycle.Monthly ? 'monthly' : 'annually';
  const tasks = getTotalCredits(currentPlan!, selectedPayCycle);
  const seats = getSeatQuantityForProduct(currentPlan!);

  return (
    <div className={classes.container}>
      <div className={classes.orderedListContainer}>
        <Typography className={classes.listNumber}>{order}</Typography>
        <Typography variant="h6">Current Plan Overview</Typography>
      </div>
      <div className={classes.pageContainer}>
        <Typography variant="body2" className={classes.headerSubtitle}>
          {plan} - {cycle}, {tasks} matters per billing period, {seats} user license seats
        </Typography>
        <TaskOverview portalId={portalId} />
      </div>
    </div>
  );
};
